$(document).ready(function () {
  //hyQuest.console.clear(); //clear the console

  hyQuest.form.dynamicForm(); //form dynamisation
  hyQuest.form.dummyLink(); //avoid page scrolling when an empty link is clicked
  hyQuest.form.formValidation(); //insert error messages into mandatory fields
  hyQuest.form.replicate(); 
  hyQuest.form.deleteLine(); 
  hyQuest.form.modalInfos(); //Dettach and append modal-Infos

  $('#modal-Infos').modal('show');
  $('[data-toggle="popover"]').popover().click(function () {
    $(this).trigger('focus');
  });

});


function incNameIndex($html){
    $html.find('input').each(function() {
        var $name = $(this).attr('name');
        var $tKey = $name.split('[');
        var newIndex = parseInt(parseInt($tKey[2].replace(']','')) + 1);
        $tKey[2] = newIndex + ']';
        var $newName = $tKey.join('[');
        $(this).attr('name', $newName);
        $(this).val('');
    })
};

var hyQuest = {
  console: {
    clear: function clear() {
      console.clear();
    }
  },
  form: {
    dynamicForm: function dynamicForm() {
      var $formControl = $('input,textarea,select');

      $formControl.on('change keyup', function () {

        //console.log($(this).val());

        $formControl.each(function () {
          //run through all form elements
          var $this = $(this);
          if ($this.attr('data-cond')) {
            var cond = $this.attr('data-cond'); //get data-cond parametter
            //cond =  "[(#c4_contraception=='yes'),(#c4_contraception=='no')]"
            var show = $this.attr('data-show'); //get data-show parametter
            var hide = $this.attr('data-hide'); //get data-hide parametter

            var cond_regexp = /(&&|\|\|)?\(([#.A-Za-z0-9_-]+)([<>=!]+)(['" A-Za-z0-9]*)/gi;
            var cond_cpt = (cond.match(cond_regexp) || []).length;

            var condition = '';
            for (var x = 1; x <= cond_cpt; x++) {
              var match = cond_regexp.exec(cond); //extract all matches
              // rewrite the condition properly with jQuery
              condition += (match[1] || '') + ' ($("' + match[2] + '").val() ' + match[3] + ' ' + match[4] + ') ';
            }

            condition = condition.trim();

            //console.debug(condition);

            if (eval(condition)) {
              //evaluate the data-cond
              $(show).addClass('action-open'); //show data-show listed elements if condition true
              $(hide).addClass('action-close'); //hide data-hide listed elements if condition true
            } else {
              $(show).addClass('action-close'); //hide data-show listed elements if condition false
              $(hide).addClass('action-open'); //show data-hide listed elements if condition false
            }
          }
        });

        $('.action-open').slideDown().removeClass('action-open');
        $('.action-close').slideUp().removeClass('action-close');
      });
    },
    dummyLink: function dummyLink() {
      $('a[href="#"]').on('click', function (e) {
        e.preventDefault();
      });
    },
    formValidation: function formValidation() {
      var $input = $('.form-group.mandatory .form-control');
      $input.on('change', function () {
        var $formGroup = $(this).closest('.form-group');
        if ($(this).val().trim() == '') {
          if (!$formGroup.hasClass('has-error')) {
            $formGroup.addClass('has-error has-feedback');
            $formGroup.append('<span class="help-block help-block-error" style="display:none">Ce champ est obligatoire</span>');
            $formGroup.find('.help-block-error').slideDown();
          }
        } else {
          $formGroup.removeClass('has-error has-feedback');
          $formGroup.find('.help-block-error').slideUp(function () {
            $(this).remove();
          });
        }
      });
    },
    replicate: function replicate() {
      $('.add-medicament').on('click', function(e){
        e.preventDefault();
        var $row = $(this).parent().find('.to-duplicate').last();
        if($row.hasClass('hide')) {
          $row.removeClass('hide');
        } else {
          var $rowClone = $row.clone(true, true).hide();
          if($rowClone.hasClass('hide')){
              $rowClone.removeClass('hide');
          }
          incNameIndex($rowClone);
          $row.after($rowClone.show());
        }
      })
    },
    deleteLine: function deleteLine() {
      $('.remove-medicament__link').on('click', function(){
        var $row = $(this).closest('.to-duplicate');
        $row.remove();
      });
    },
    modalInfos: function modalInfos() {
      $('#modal-Infos').on('show.bs.modal', function () {
        var modl = $('#modal-Infos').detach();
        modl.insertBefore('.paginator-progress-top');
        $('body').addClass('info-open');
      });
      $('#modal-Infos').on('hidden.bs.modal', function () {
        $('body').removeClass('info-open');
      });
    }
  }
};
